import clsx from 'clsx'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { PHONE_VERIFICATION_IMAGE } from 'src/config/imageUrls'
import { TEST_IDS } from 'src/constants/testIds'
import OtpInput from '@components/OtpInput/OtpInput'
import { getAvailableFromForPhone, useVerifyPhoneContext } from '@context/VerifyPhoneContext'
import { useCountdown } from '@hooks/useCountdown'
import useStyles from './styles'
import { Alert } from '@mui/material'

interface Props {
  onCodeChange: (value: string[]) => void
  sendSmsCode: () => void
  handleSubmit: () => void
  errorMessage?: string
  code: string[]
  phone: string
  content: React.ReactNode
}

export const PhoneVerificationBody = ({
  onCodeChange,
  sendSmsCode,
  handleSubmit,
  errorMessage,
  code,
  phone,
  content,
}: Props) => {
  const classes = useStyles()

  return (
    <div className={classes.root}>
      <div>
        {content}
        {errorMessage && (

          <Alert className={classes.error} severity='error'>{errorMessage}</Alert>
        )}
        <div className={classes.codeInputContainer}>
          <OtpInput
            handleSubmit={handleSubmit}
            onChange={onCodeChange}
            value={code}
            isValid={code.every((character) => !!character)}
          />
        </div>
        <Timer sendSmsCode={sendSmsCode} phone={phone} />
      </div>
      <div className={classes.imageContainer}>
        <img className={classes.image} src={PHONE_VERIFICATION_IMAGE} alt="phone-sms" />
      </div>
    </div>
  )
}

const Timer = ({ sendSmsCode, phone }: Pick<Props, 'sendSmsCode' | 'phone'>) => {
  const classes = useStyles()
  const { t } = useTranslation()
  const { verifyInfo } = useVerifyPhoneContext()
  const availableFrom = getAvailableFromForPhone(verifyInfo, phone)
  const { minutes, seconds } = useCountdown(availableFrom || '')

  if (!availableFrom || isNaN(minutes) || isNaN(seconds) || (minutes <= 0 && seconds <= 0)) {
    return (
      <div
        className={clsx(classes.verifyText, classes.verifyTextHover)}
        onClick={sendSmsCode}
        data-test={TEST_IDS.requestNewOtp}
      >
        {t('verify_phone_page_resend')}
      </div>
    )
  }

  const minutesToDisplay = minutes.toString().length === 1 ? `0${minutes}` : minutes
  const secondsToDisplay = seconds.toString().length === 1 ? `0${seconds}` : seconds

  return (
    <div className={classes.verifyText} data-test={TEST_IDS.requestNewOtp}>
      {t('verify_phone_page_resend')} ({minutesToDisplay}:{secondsToDisplay})
    </div>
  )
}
